<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_PACOTE_CENTRAL_CLIENTE')">
            <form>
                <div class="formgroup">
                    <div class="flex justify-content-center" *ngIf="loading">
                        <p-progressSpinner></p-progressSpinner>
                    </div>
                    <div *ngIf="messagemVisivel" class="w-auto mb-5">
                        <p-messages
                            [(value)]="messages"
                            [enableService]="false"
                            [closable]="true"
                        ></p-messages>
                    </div>
                    <div
                        class="p-fluid p-formgrid grid pt-3 px-3"
                        *ngIf="orcamento && !isExibirSpinnerPrincipal()"
                    >
                        <div class="col-12 card-simple">
                            <div class="grid justify-content-between">
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Nª Pacote</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-objects-column mr-1"></i>
                                        {{ orcamento.numeroOrcamento }}
                                    </label>
                                </div>

                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Cliente</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-user mr-1"></i>
                                        {{ orcamento.interessado?.nome }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Data</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-calendar mr-1"></i>
                                        {{ orcamento.dataOrcamento | date: "dd/MM/yyyy" }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Valor Pago</label>
                                    <label class="form-control-sem-borda">
                                        <i class="pi pi-money-bill mr-1"></i>
                                        {{ orcamento.valorPago ?? 0 | currency: "BRL" }}
                                    </label>
                                </div>
                                <div class="field col-12 md:col-6 xl:col-2">
                                    <label class="label-sem-borda-bottom">Situação</label>
                                    <label class="form-control-sem-borda">
                                        <span
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            *ngIf="orcamento.status === 'RESGATADO_CREDITO_CLIENTE'"
                                            pTooltip="Resgate com geração de crédito na conta do Cliente"
                                        >
                                            RESGATADO SALDO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'RESGATADO_PAGO'"
                                            class="product-badge bg-gray-600 admihair-text-white"
                                            pTooltip="Resgatado com pagamento ao Cliente"
                                        >
                                            RESGATADO PAGO
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'PAGO'"
                                            class="product-badge bg-blue-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'FINALIZADO'"
                                            class="product-badge bg-green-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'ABERTO'"
                                            class="product-badge bg-teal-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                        <span
                                            *ngIf="orcamento.status === 'VENCIDO'"
                                            class="product-badge bg-red-600 admihair-text-white"
                                        >
                                            {{ orcamento.status }}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            class="w-full flex justify-content-end mt-2"
                            *ngIf="orcamento.tipo === 'PACOTE' && orcamento.status === 'PAGO'"
                        >
                            <button
                                pButton
                                pRipple
                                pTooltip="Resgatar"
                                icon="pi pi-history"
                                label="Resgatar"
                                class="p-button-outlined w-auto"
                                (click)="abrirDialogResgatePacote()"
                            ></button>
                        </div>

                        <div class="w-full mt-5">
                            <div>
                                <h5>Itens</h5>
                            </div>
                            <p-table
                                #dt1
                                [value]="itensOrcamento"
                                dataKey="id"
                                [rows]="10"
                                [rowHover]="true"
                                [paginator]="false"
                                responsiveLayout="stack"
                                styleClass=" p-datatable-sm"
                            >
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Serviço</th>
                                        <th>Quantidade</th>
                                        <th>Entregue</th>
                                        <th>Saldo</th>
                                        <th>Saldo(R$)</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td>
                                            <label>{{ item.nomeItem }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeProposta }}</label>
                                        </td>
                                        <td>
                                            <label>{{ item.quantidadeEntregue }}</label>
                                        </td>

                                        <td>
                                            <label>
                                                {{
                                                    item.quantidadeProposta -
                                                        item.quantidadeEntregue
                                                }}
                                            </label>
                                        </td>
                                        <td>
                                            {{ calcularValorAResgatar(item) | currency: "BRL" }}
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div
                                        class="flex flex-column align-items-end justify-content-end"
                                    >
                                        <div>
                                            Saldo total:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                        <div *ngIf="orcamento.status === 'PAGO'">
                                            Valor a resgatar:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                        <div
                                            *ngIf="
                                                orcamento.status === 'RESGATADO_CREDITO_CLIENTE' ||
                                                orcamento.status === 'RESGATADO_PAGO'
                                            "
                                        >
                                            Valor resgatado:
                                            {{ orcamento.totalResgatar | currency: "BRL" }}
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7">Nenhum registro cadastrado.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem mt-5"
                                routerLink="/apps/central-cliente/pacote/"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<p-dialog
    header="Resgate de Pacote"
    [(visible)]="exibirDialogResgate"
    [modal]="true"
    [style]="{ width: '40vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
>
    <div class="flex justify-content-center" *ngIf="loadingPacote">
        <p-progressSpinner></p-progressSpinner>
    </div>

    <div class="flex justify-content-between mb-5" *ngIf="!loadingPacote">
        <div class="w-6 flex flex-column gap-2">
            <span>Escolha uma opção:</span>
            <div class="field-radiobutton">
                <p-radioButton
                    name="tipoResgate"
                    value="PAGAMENTO"
                    [(ngModel)]="tipoResgate"
                    id="tipoResgate1"
                ></p-radioButton>
                <label for="tipoResgate1">Pagar ao Cliente</label>
            </div>

            <div class="field-radiobutton">
                <p-radioButton
                    name="tipoResgate"
                    value="CREDITO"
                    [(ngModel)]="tipoResgate"
                    id="tipoResgate2"
                ></p-radioButton>
                <label for="tipoResgate2">Gerar Crédito</label>
            </div>
        </div>
        <div class="w-6 flex flex-column gap-2" *ngIf="tipoResgate === 'PAGAMENTO'">
            <div>
                <label htmlFor="tipoPagamento">Forma de Pagamento</label>
                <p-dropdown
                    class="p-fluid"
                    [options]="listaTiposPagamento"
                    optionLabel="descricao"
                    placeholder="Selecione"
                    name="tipoPagamento"
                    ngModel
                    #tipoPagamento="ngModel"
                    [filter]="true"
                    [required]="true"
                    [(ngModel)]="tipoPagamentoSelecionado"
                    appendTo="body"
                ></p-dropdown>
            </div>
            <div>
                <label htmlFor="dataPagamento">Data de Pagamento</label>
                <p-calendar
                    class="p-fluid"
                    [readonlyInput]="false"
                    [showIcon]="true"
                    dateFormat="dd/mm/yy"
                    [showButtonBar]="true"
                    name="dataPagamento"
                    ngModel
                    [(ngModel)]="dataPagamentoSelecionada"
                    #dataPagamento="ngModel"
                    [required]="true"
                    appendTo="body"
                ></p-calendar>
            </div>
        </div>
    </div>
    <div *ngIf="!loadingPacote">
        <span class="text-lg">
            Total a resgatar: {{ orcamento?.totalResgatar | currency: "BRL" }}
        </span>
    </div>

    <div class="flex justify-content-end mt-2">
        <button
            *ngIf="
                tipoResgate === 'CREDITO' ||
                    (tipoResgate === 'PAGAMENTO' && tipoPagamentoSelecionado);
                else botaoFalso
            "
            type="button"
            pButton
            class="p-button-outlined w-12rem h-3rem"
            [icon]="loadingResgate ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
            label="Confirmar"
            [disabled]="loadingResgate"
            (click)="resgatarPacote()"
        ></button>
        <ng-template #botaoFalso>
            <button
                type="button"
                pButton
                class="p-button-outlined w-12rem h-3rem"
                icon="pi pi-check"
                label="Confirmar"
                disabled
            ></button>
        </ng-template>
    </div>
</p-dialog>
